export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body !== undefined) headers.set("Content-Type", "application/json");
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "same-origin",
  });
  const data = (await response.json().catch(() => null)) as
    | { error?: string }
    | T
    | null;
  if (!response.ok) {
    if (response.status === 401)
      window.dispatchEvent(new CustomEvent("huopan:unauthorized"));
    const message = data && typeof data === "object" && "error" in data
      ? data.error
      : undefined;
    throw new Error(message || `请求失败（${response.status}）`);
  }
  return data as T;
}
